import React, { ReactElement, ReactNode, useState } from 'react'
import Button from '../../../components/Buttons/Button'
import Dialog from '../../../components/Dialog/Dialog';
import { MdInfo } from 'react-icons/md';
import { Parser } from "html-to-react";

const InstitucionalDesing = ({ institucional }: { institucional: string }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    interface AnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> { }

    function updateLinks(children: ReactNode): ReactNode {
        return React.Children.map(children, (child) => {
            if (React.isValidElement(child) && child.type === 'a') {
                return React.cloneElement(child as ReactElement<AnchorProps>, {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                });
            }
            return child;
        });
    }

    return (
        <>
            <div className='rounded-sm bg-brand-green-5'>
                <div className='p-4 flex flex-col md:flex-row gap-6 justify-between items-left md:items-center'>
                    <div className='flex flex-col gap-1'>
                        <p className='text-bmedium font-bold'>Diseño institucional</p>
                        <p className='text-bmedium'>Detalle de los organismos, jurisdicciones o entidades estatales que tienen a su cargo la elaboración y ejecución de las estrategias, políticas y programas dirigidos a garantizar el derecho.</p>
                    </div>
                    <Button
                        label='Ver'
                        onClick={() => setIsOpen(!isOpen)}
                        variant='outline-orange'
                        className='bg-primary-100'
                    />
                </div>
            </div>

            <Dialog isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} bgColor='bg-brand-green-5' >
                <div className='flex gap-3 flex-col'>
                    <div className='flex flex-col items-center'>
                        <MdInfo size={32} color="#205253" />
                        <p className='text-hsmall'>Diseño institucional</p>
                    </div>
                    {
                        institucional && <span className='text-bmedium text-system-light-40'>{updateLinks(Parser().parse(institucional).props.children)}</span>
                    }
                </div>
            </Dialog>
        </>
    )
}

export default InstitucionalDesing